import React from 'react';
import PropTypes from 'prop-types';
import { Message, translator } from 'mage-i18n';
import { gridCalculator, ProductPricing } from 'moet-core';
import { connect } from 'react-redux';
import { getMerchantCountryKey } from '@/selectors/merchant';

import Table from './Table';

// total number of the columns in the TableForChildrenPricedProduct
const MAX_NUMBER_OF_PRICING_TABLE_COLUMNS = 5;
const MAX_NUMBER_OF_COLUMNS = gridCalculator.MAX_NUMBER_OF_COLUMNS;
const tKey = 'products-fe.components.global_prices_dialog';
const tKeyProducts = 'moet-core.products';

const TableForParentPricedProduct = ({ countryCode, prices, productId, t }) => {
  const headerCells = [
    <Message key="title" path={`${tKey}.table.country`} />,
    <Message
      key={productId}
      path={
        productId === 'kp_one'
          ? `${tKey}.table.headers.${productId}` // for KP one we show a generic header
          : `${tKeyProducts}.${productId}.name.${countryCode}`
      }
      fallback={t(`${tKeyProducts}.${productId}.name.default`)}
    />,
  ];

  // eslint-disable-next-line max-len
  const widthOfTheFirstColumn = (MAX_NUMBER_OF_COLUMNS / MAX_NUMBER_OF_PRICING_TABLE_COLUMNS) * 2; // 2/5 of the widths
  // eslint-disable-next-line max-len
  const widthOfTheSecondColumn = (MAX_NUMBER_OF_COLUMNS / MAX_NUMBER_OF_PRICING_TABLE_COLUMNS) * 3; // 3/5 of the widths

  const rows = prices.map((price, index) => {
    const countryNameCell =
      price.consumerCountry === null ? (
        <Message key={index} path={`${tKey}.table.global`} />
      ) : (
        <Message key={index} path={`products-fe.countries.${price.consumerCountry}`} />
      );

    return [
      countryNameCell,
      <ProductPricing
        key="price"
        price={price}
        withFootnoteAsterisk={price.global}
        showPerTransactionText={false}
      />,
    ];
  });

  return (
    <Table
      headerCells={headerCells}
      rows={rows}
      widths={[widthOfTheFirstColumn, widthOfTheSecondColumn]}
      striped
    />
  );
};

TableForParentPricedProduct.propTypes = {
  countryCode: PropTypes.string.isRequired,
  prices: PropTypes.array.isRequired,
  productId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default connect(state => ({
  countryCode: getMerchantCountryKey(state),
  t: translator(state),
}))(TableForParentPricedProduct);
